import '/assets/styles/pages/login.scss';
import { useEffect } from 'react';

// Partials
import Img from '@wearetla/tla-essentials-tools/partials/img';

// Context
import { useModals } from '@wearetla/tla-essentials-tools/utilities/modals';
import { useApplication } from '/utilities/application';
import { useNavigator } from '@wearetla/tla-essentials-tools/utilities/navigator';

// Static Assets
import image_logo from '/assets/images/logo-white.svg';

const Login = () => {
	const { isApplication } = useApplication();
	const { openModal } = useModals();
	const { redirect } = useNavigator();

	useEffect(() => {
		if (isApplication) {
			openModal('auth');
			redirect('home');
		} else {
			redirect('web-landing');
		}
	}, [isApplication]);

	return (
		<>
			<Img src={image_logo} lazy={false} className="login-logo" alt="IF Sokak" />
		</>
	);
};

export default Login;
